// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uppy-DragDrop-container {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  font-family: -apple-system, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", "Segoe UI Symbol", "Segoe UI Emoji", "Apple Color Emoji", Roboto, Helvetica, Arial, sans-serif;
  background-color: #fff;
  border-radius: 7px;
  cursor: pointer;
}
.uppy-DragDrop-container::-moz-focus-inner {
  border: 0;
}
.uppy-DragDrop-container:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.4);
}

.uppy-DragDrop-inner {
  margin: 0;
  padding: 80px 20px;
  line-height: 1.4;
  text-align: center;
}

.uppy-DragDrop-arrow {
  width: 60px;
  height: 60px;
  margin-bottom: 17px;
  fill: #e0e0e0;
}

.uppy-DragDrop--isDragDropSupported {
  border: 2px dashed #adadad;
}

.uppy-DragDrop--isDraggingOver {
  background: #eaeaea;
  border: 2px dashed #1269cf;
}
.uppy-DragDrop--isDraggingOver .uppy-DragDrop-arrow {
  fill: #939393;
}

.uppy-DragDrop-label {
  display: block;
  margin-bottom: 5px;
  font-size: 1.15em;
}

.uppy-DragDrop-browse {
  color: #1269cf;
  cursor: pointer;
}

.uppy-DragDrop-note {
  color: #adadad;
  font-size: 1em;
}`, "",{"version":3,"sources":["webpack://./node_modules/@uppy/drag-drop/dist/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gPAAqK;EACrK,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB","sourcesContent":[".uppy-DragDrop-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 100%;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", \"Segoe UI Symbol\", \"Segoe UI Emoji\", \"Apple Color Emoji\", Roboto, Helvetica, Arial, sans-serif;\n  background-color: #fff;\n  border-radius: 7px;\n  cursor: pointer;\n}\n.uppy-DragDrop-container::-moz-focus-inner {\n  border: 0;\n}\n.uppy-DragDrop-container:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.4);\n}\n\n.uppy-DragDrop-inner {\n  margin: 0;\n  padding: 80px 20px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.uppy-DragDrop-arrow {\n  width: 60px;\n  height: 60px;\n  margin-bottom: 17px;\n  fill: #e0e0e0;\n}\n\n.uppy-DragDrop--isDragDropSupported {\n  border: 2px dashed #adadad;\n}\n\n.uppy-DragDrop--isDraggingOver {\n  background: #eaeaea;\n  border: 2px dashed #1269cf;\n}\n.uppy-DragDrop--isDraggingOver .uppy-DragDrop-arrow {\n  fill: #939393;\n}\n\n.uppy-DragDrop-label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 1.15em;\n}\n\n.uppy-DragDrop-browse {\n  color: #1269cf;\n  cursor: pointer;\n}\n\n.uppy-DragDrop-note {\n  color: #adadad;\n  font-size: 1em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
